import { KeyValue } from './KeyValue';

export interface AppKeyValues {
    [name: string]: KeyValue[]
}
